import enLocale from 'element-ui/lib/locale/lang/en'

export default {
    app: {
        title: 'Document Similarity Detection System',
        alias: '查大同 · 識小異',
        simple: 'Concise',
        origin: 'Original text',
        detail: 'Detailed fragment',
        full: 'Full text comparison',
        preservation: '存檔報告'
    },
    info: {
        paperInfo: '送檢文獻信息',
        title: '【Title】',
        author: 'Author',
        name: '姓名',
        stuNum: '學號',
        tutor: '導師',
        origin: '來源',
        receive: 'Received',
        receive2: '學位授予時間',
        checkTime: 'Detected',
        checkLimit: '檢測範圍',
        allPerc: 'Similar',
        referenceCopyPercent: 'Reference Similarity',
        selfCopyPercent: 'Self-referential Similarity'
    },
    cr: {
        result: '檢測結果',
        word: '字',
        jian: '檢',
        can: '參',
        zi: '自',
        fa: '法',
        zhuan: '專',
        validTextNum: '原文總字符數',
        fullTextNum: '檢測字符數',
        refCopyPer: '參考文獻相似比',
        exRefCopyPer: '輔助排除參考文獻相似比',
        selfCopyPer: '可能自引相似比',
        exSelfCopyPer: '輔助排除可能自引相似比',
        lawsCopyPer: '法律法規文獻相似比',
        exLawsCopyPer: '輔助排除法律法規相似比',
        termsCopyPer: '專名術語相似比'
    },
    crd: {
        detailResult: '詳細檢測結果',
        paraNum: '原文總段落數',
        simiCount: 'Similar words',
        maxSimiScale: '單篇最大相似比',
        maxSimiNum: '單篇最大相似字符數',
        maxSimiTitle: '單篇最大相似文獻',
        no: '無',
        tableNum: 'Table'
    },
    explain: {
        seal: '蓋章處',
        reportIndex: '報告指標說明',
        indicators1: '原文總字符數：即送檢文獻的總字符數，包含文字字符、標點符號、阿拉伯數字（不計入空格）',
        indicators2: '檢測字符數：送檢文獻經過系統程序處理，排除已識別的參考文獻等不作為相似性比對內容的部分後，剩余全部參與相似性檢測匹配的文本字符數',
        indicators3: '總相似比：送檢文獻與其他文獻的相似文本內容在原文中所占比例',
        indicators4: '參考文獻相似比：送檢文獻與其標明引用的參考文獻的相似文本內容在原文中所占比例',
        indicators5: '可能自引相似比：送檢文獻與其作者本人的其他已公開或發表文獻的相似文本內容在原文中所占比例',
        indicators6: '單篇最大相似比：送檢文獻的相似文獻中貢獻相似比最高壹篇的相似比值',
        indicators7: '是否引用：該相似文獻是否被送檢文獻標註為其參考文獻引用，作者本人的可能自引文獻也應標註為參考文獻後方能認定為“引用”',
        indicators8: '法律法規文獻相似比：送檢文獻與“中國法律法規數據庫”中文獻的相似文本內容在原文中所占比例（新增內容）',
        indicators9: '專名術語相似比：相似文本中，「專用名詞和專業術語」在原文中所占比例'
    },
    full: {
        colorIntro: '報告顏色標註說明',
        green: 'Green:',
        refCopyPer: 'references similarity',
        yellow: 'Yellow:',
        selfCopyPer: 'self-referential similarity',
        red: 'Red:',
        other: 'other similarities except for references and self-referenti',
        blue: '藍色',
        lawCopyPer: '代表法律法規文獻相似比',
        wfbc: '代表相似比',
        clickIntro: 'Please click on the text with color markings in the document to view similar fragments',
        isRef: '是否引用',
        yes: 'YES',
        no: 'NO',
        similarPart: 'Similar Fragments',
        partSimiNum: 'Similar words',
        reportId: '  Report No. ',
        originMark: 'ORIGINAL TEXT',
        unfold: 'Expand',
        fold: 'Collapse'
    },
    fOrH: {
        intro: 'This report is generated by the Wanfang Data Document Similarity Detection System algorithm. It is only responsible for the test results within the test range you selected and the results are for reference only.',
        web: 'Official Website',
        truth: 'Report Authenticity Verification Official Website',
        wf: '北京萬方數據股份有限公司出品',
        oneReport: '壹對壹檢測報告',
        downReport: 'Download',
        downing: 'The report is being downloaded, please be patient and wait'
    },
    sign: {
        org: '檢測機構（蓋章）',
        signature: '簽字處',
        subMan: '提交人',
        subOrg: '提交人所在單位',
        isWf: '送檢論文是否為萬方數據庫內查找',
        inspector: '檢索檢測員',
        monitors: '監督員'
    },
    simi: {
        simiList: 'SIMILARITY INDEX',
        listCount: 'Only list the top {len} literature',
        index: 'Num',
        perc: 'Similar',
        simiPaper: 'Similar literature',
        type: '類型',
        isRef: 'Quoted',
        char: 'words',
        simiChart: '相似片段分布圖',
        simiDetail: 'DETAILED FRAGMENT',
        originPart: 'Original Text',
        position: '位置'
    },
    one: {
        thanInfo: '比對文獻信息',
        indicators1: '比對文獻是否為參考文獻：該比對文獻是否被送檢文獻標註為其參考文獻引用',
        indicators2: '比對文獻是否可能為自引文獻：比對文獻作者是否與送檢文獻作者一致',
        thanPart: '比對文獻片段'
    },
    error: {
        text1: '抱歉！您訪問的頁面不存在',
        text2: '請檢查網址是否正確'
    },
    ...enLocale
}